import axios from './axios';

export default {
  list: () => axios.get('/it_operateurs'),
};
